// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1ofSc","validationTips":"StatementDescriptor_validationTips__3NQiK"};